<div class="content">
    <div class="card m-5">
        <div class="card-body">
            <h4 class="card-title">Reset Password</h4>
            <small style="font-size: 16px;margin-bottom: 15px;">Please enter and re-enter your new password. Must be
                between 6 and 30 characters in length.
            </small>
        <div *ngIf="showError" class="err-msg"><b>{{errorMessage}}</b></div>

            <form style="margin-top: 20px;" action="javascript:alert(grecaptcha.getResponse(widgetId1));"
                [formGroup]="resetForm">
                <div class="form-group">
                    <input type="password" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                        placeholder="Password" formControlName="password" [class.invalid]="(resetFormControl['password'].valid || submitted) && resetFormControl.password.errors?.required || resetForm.errors?.noMatch && submitted">
                        <span class="text-danger"
                        *ngIf="(resetFormControl['password']?.valid || submitted) && resetFormControl['password']?.hasError('required')">
                        Password is required
                    </span>

                    <span class="text-danger"
                        *ngIf="resetFormControl['password']?.invalid  && (resetFormControl['password']?.errors?.minlength || resetFormControl['password']?.errors?.maxLength)">
                        Password must between 6 to 30 charactes long
                    </span>
                </div>
                <div class="form-group" style="margin-top: 20px;">
                    <input type="password" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                        placeholder="Confirm Password" formControlName="confrimPassword"  [class.invalid]="(resetFormControl['confrimPassword'].valid || submitted) && resetFormControl.confrimPassword.errors?.required || resetForm.errors?.noMatch && submitted">
                        <span class="text-danger"
                        *ngIf="(resetFormControl['confrimPassword']?.valid || submitted) && resetFormControl['confrimPassword']?.hasError('required')">
                        Confirm Password is required
                    </span>

                    <span class="text-danger"
                        *ngIf="resetFormControl['confrimPassword']?.invalid  && (resetFormControl['confrimPassword']?.errors.minlength || resetFormControl['confrimPassword']?.errors.maxLength)">
                        Password must between 6 to 30 charactes long
                    </span>

                    <span class="text-danger"
                    *ngIf="resetForm.errors?.noMatch && submitted && !resetFormControl['confrimPassword']?.invalid && !resetFormControl['confrimPassword']?.hasError('required')">
                    Both passwords are not the same
                </span>
                </div>

                <div class="signin-btn">
                    <button type="submit" class="btn btn-primary" (click)="onSubmit()">Verify</button>
                </div>
            </form>

        </div>
    </div>
</div>